import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormBuilder, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { AppCommonModule } from 'src/app/common.module';
import { ModalShellComponent } from 'src/app/ui/modal-shell/modal-shell.component';

@Component({
  selector: 'app-project-template-dialog',
  templateUrl: './project-template.dialog.html',
  styleUrls: ['./project-template.dialog.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AppCommonModule,
    ModalShellComponent,
  ],
})
export class ProjectTemplateDialogComponent {
  private formBuilder = inject(FormBuilder);
  private _modal = inject(ModalController);

  formGroup = this.formBuilder.group({
    name: ['', Validators.required],
    periods: this.formBuilder.array([]),
  });

  periodsArray = this.formGroup.get('periods') as FormArray;

  periodTicketsArrays: FormArray[] = [];

  addItem() {
    const item = this.formBuilder.group({
      name: ['', Validators.required],
      tickets: this.formBuilder.array([]),
    });
    this.periodsArray.push(item);
    this.periodTicketsArrays.push(item.get('tickets') as FormArray);
  }

  deleteItem(index: number) {
    this.periodsArray.removeAt(index);
    this.periodTicketsArrays.splice(index, 1);
  }

  addTicket(index: number) {
    const item = this.formBuilder.group({
      name: ['', Validators.required],
    });
    this.periodTicketsArrays[index].push(item);
  }

  deleteTicket(parentIndex: number, index: number) {
    this.periodTicketsArrays[parentIndex].removeAt(index);
  }

  save() {
    const item = this.formGroup.value;
    this._modal.dismiss(item);
  }

  dismiss() {
    this._modal.dismiss();
  }
}
